/**
 * Die Leiste, die erscheint, sobald etwas ausgewählt ist.
 *
 * Sie klebt am unteren Rand der Positionsliste, damit sie beim Durchgehen
 * einer langen Liste nicht wegscrollt. Die Aktion steht bewusst **nach** der
 * Auswahl: erst sammeln, was zusammengehört, dann entscheiden, was damit
 * passiert.
 */

export type SelectionBarProps = {
  anzahlPositionen: number;
  anzahlBloecke: number;
  /** Zeilen, die beim Kopieren tatsächlich mitgehen (Blockpositionen mitgezählt). */
  anzahlZeilen: number;
  onKopieren: () => void;
  onPackzettel: () => void;
  /** Nur sinnvoll mit gewählten Positionen — Blöcke lassen sich nicht schachteln. */
  onZuBlock: () => void;
  onAufheben: () => void;
};

export default function InvoiceSelectionBar({
  anzahlPositionen, anzahlBloecke, anzahlZeilen, onKopieren, onPackzettel, onZuBlock, onAufheben,
}: SelectionBarProps) {
  const teile = [
    anzahlBloecke > 0 ? `${anzahlBloecke} ${anzahlBloecke === 1 ? "Block" : "Blöcke"}` : "",
    anzahlPositionen > 0
      ? `${anzahlPositionen} ${anzahlPositionen === 1 ? "Position" : "Positionen"}`
      : "",
  ].filter(Boolean);

  return (
    <div className="invoice-selection-bar" role="status">
      <span className="invoice-selection-count">
        <strong>{teile.join(" · ")}</strong>
        {anzahlBloecke > 0 && (
          <small>
            {anzahlZeilen} {anzahlZeilen === 1 ? "Zeile" : "Zeilen"} insgesamt
          </small>
        )}
      </span>
      <span className="invoice-selection-actions">
        <button type="button" className="invoice-button" onClick={onAufheben}>
          Auswahl aufheben
        </button>
        {/* Zwei Wege aus derselben Auswahl: mitnehmen oder weitergeben.
            Der Packzettel steht rechts, weil er das Endgültigere ist —
            er erzeugt ein Dokument, die Ablage nur eine Notiz. */}
        {anzahlPositionen > 0 && (
          <button type="button" className="invoice-button" onClick={onZuBlock}>
            Als Block zusammenfassen
          </button>
        )}
        <button type="button" className="invoice-button" onClick={onKopieren}>
          In die Zwischenablage
        </button>
        <button type="button" className="invoice-button primary" onClick={onPackzettel}>
          Packzettel erstellen
        </button>
      </span>
    </div>
  );
}
